module.exports = __webpack_public_path__ + "static/media/AttendanceMenu.ecd32a39.svg";